import { IconButton, Text, Tooltip } from '@lego/klik-ui';
import { Trash } from '@lego/klik-ui/icons';
import type { MouseEvent } from 'react';
import { UserNameLink } from '@/components/common/UserNameLink';
import { WorkspaceTextLink } from '@/components/workspace/WorkspaceTextLink';
import { createColumnHelper } from '../appTable';

type FleetInvitationRow = {
  id: number;
  createdByOid: string | null | undefined;
  updatedAt: string;
  invitedWorkspace: number;
  fleetId: number;
  state: string;
};

const columnHelper = createColumnHelper<FleetInvitationRow>();

export const fleetInvitationTableColumns = (
  onDelete?: (invitationId: number) => Promise<void>,
  deletingIds?: Set<number>
) =>
  columnHelper.columns([
    columnHelper.accessor('id', {
      cell: (info) => (
        <Text fontFamily="mono" fontSize="sm">
          {info.getValue()}
        </Text>
      ),
      header: 'ID',
    }),
    columnHelper.accessor('createdByOid', {
      cell: (info) => <UserNameLink oid={info.getValue()} />,
      enableSorting: false,
      header: 'Created By',
    }),
    columnHelper.accessor('updatedAt', {
      cell: (info) => info.getValue(),
      header: 'Updated At',
    }),
    columnHelper.accessor('fleetId', {
      cell: (info) => (
        <Text fontFamily="mono" fontSize="sm">
          {info.getValue()}
        </Text>
      ),
      header: 'Fleet',
      meta: { filterVariant: { type: 'singleSearch' } },
    }),
    columnHelper.accessor('invitedWorkspace', {
      cell: (info) => <WorkspaceTextLink workspaceId={info.getValue()} />,
      header: 'Invited Workspace',
      meta: { filterVariant: { type: 'singleSearch' } },
    }),
    columnHelper.accessor('state', {
      cell: (info) => info.getValue(),
      header: 'State',
      meta: { filterVariant: { type: 'singleSearch' } },
    }),
    columnHelper.display({
      id: 'actions',
      header: '',
      size: 50,
      cell: ({ row }) => {
        const isDeleting = deletingIds?.has(row.original.id) ?? false;
        return (
          <Tooltip label={isDeleting ? 'Deleting…' : 'Revoke invitation'}>
            <IconButton
              aria-label="Delete fleet invitation"
              icon={<Trash />}
              isDisabled={!onDelete || isDeleting}
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                void onDelete?.(row.original.id);
              }}
              opacity={isDeleting ? 0.4 : 1}
              size="sm"
              variant="ghost"
            />
          </Tooltip>
        );
      },
    }),
  ]);
